module.exports = __webpack_public_path__ + "static/media/concept.74e8020a.JPG";